import React, { Component, Fragment } from 'react';
import axios from 'axios'
import moment from 'moment';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import styles from "./styles";
import PageHeader from "./helper/PageHeader";
import PageFooter from "./helper/PageFooter";
import { getTrainingProviderData, getTrainingProviderOptions, getWorkshopData } from './helper/APIcalls';

import Loading from './helper/Loading';
import { GridAutoTextValidator } from './helper/GridComponents';
import { WaiveDialog } from './helper/Dialogs';
import { authContext } from "../context/AuthContext";

import DeleteIcon from '@mui/icons-material/Delete';
import { languages } from '../constants/global'

import LocationBox from './helper/LocationBox';
import ContactBox from './helper/ContactBox';

// datesChanged state issue: if the dates were modified (issue: if the dates were changed, and then changed back -> would still show up as changed)

// fix for invisible links
const anchorColor = {
    color: "#0d6efd"
}

// if id is defined, assumed to be view workshop unless edit specified
// if id not defined, checks if trainingProvider specified -> if it is, imports training provider data
class Workshop extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);
        // only admins can go above 25
        if (!ValidatorForm.hasValidationRule('isLess25')) {
            ValidatorForm.addValidationRule('isLess25', (value) => {
                if (this.context.roles.isClassroomTrainingAdmin===1 || this.context.roles.isProgramCoordinator===1) {
                    console.log('1');
                    return true
                } 
                // if admin, then there is no need to check
                else if (this.state.isRemote && value <= 10){
                    console.log('2');
                    return true
                }

                else if (!this.state.isRemote && value <= 30){
                    console.log('3');
                    return true
                }  // if the value is over 25
            

                return false
            });
        }

        ValidatorForm.addValidationRule('checkTrainingDate', (value) => {
            // let currDate = new Date()
            // currDate.setFullYear(currDate.getFullYear()-1);
            // currDate = moment(currDate).format('YYYY-MM-DD')
            let setDate = moment('2000-01-01').format('YYYY-MM-DD')
            let currDate = moment(value).format('YYYY-MM-DD')
            let checkDateRange = currDate > setDate ? true : false
            // console.log('checkDateRange', checkDateRange);
            if(  (!(moment(value).isValid())) || !checkDateRange  ){
                return false;
            }

            return true;
        });

        
        // admin roles from context
        this.editing = false;
        if (this.props.location.state && this.props.location.state.editing !== undefined) {
            this.editing = true;
        }

        this.state = {
            submitting: false,

            loading: true,

            error: '',

            datesDisabled: false, // if the workshop is published and the user is not an admin, then this is true

            id: this.props.match.params.id || null,
            workshopID: '', // this is the visible ID, different from the above

            showDialog: false,

            // only show the waiver if the dates were changed on an existing waivered workshop
            datesChanged: false,
            hasWaiver: false, // I could have just checked if the ID was not null (updating workshop) but then if you make the workshop but don't submit waiver...

            // autocomplete options
            categories: [],
            organizations: [],
            organizationsFiltered: [],
            instructors: [],
            leadInstructors: [],
            locTemplates: [],
            contactTemplates: [],
            programs: [],
            counties:[],
            states: [],

            // field data
            category: null,
            regCloseDate: '',
            regExtUrl: null,
            lang: null,
            cost: '',
            maxParticipants: '',
            minParticipants: '',
            description: '', // class details, get set in the backend
            advertisingWebSite: '',
            leadInstructor: null,
            organization: null, //{ label: null, value: null },
            program: null, //{ label: null, value: null },
            notes: '', // event day details

            isPublic: false,
            isRemote: false,
            remotePlatform: '',

            dates: [],

            locTemplate: '',
            locationName: '',
            locationStreet: '',
            locationCity: '',
            locationCounty: null,
            locationZipcode: '',
            locationStateCode: null,
            locationMapURL: '',

            contact: { FIRSTNAME: null, PHONE: null },
            contactTemplate: '',
            contactFirstname: '',
            contactLastname: '',
            contactPhone: '',
            contactEmail: '',
            modules: [],
            workshopProgram: { title: '' },
            modulePresenters: [],
            location: { NAME: null, STREET: null, CITY: null },

            costErrorMessage : 'Cost must be less than $30',

            trainingCode: '',
            audience: '',
            usedBy:'',
            lastModifiedByUserName:'', 
            trainingProviders:[],
            trainingProvider: null,
            trainingProviderId: null,
            trainingProviderName:''
        }
    }


    // IF the program changes, get the module presenters that go with that program
    onProgramChange = (event, value) => {
        let selected = value;

       // console.log(selected)
        // if program is null, do nothing
        if (selected === null) {
            return
        }

        // get the module presenters that go with the program ID
        axios.get('/api/program/' + selected.value, {
        }).then((res) => {
            let index = -1;
            // console.log(res.data.modules)
            let mp = res.data.modules.map((u) => {
                index = this.state.modulePresenters.findIndex(e => e.moduleId === u.ID); // grabs current module presenter state

                // if the current module presenter exists in the modulePresenters state (index!= -1) and the module presenter is valid (exists in the instructor list)
                if (index > -1 && this.state.instructors.findIndex(e => e.value === this.state.modulePresenters[index].instructorId) !== -1)
                    return {
                        moduleId: u.ID,
                        moduleName: u.moduleName,
                        instructorName: this.state.modulePresenters[index].instructorName,
                        instructorId: this.state.modulePresenters[index].instructorId
                    };
                else
                    return {
                        moduleId: u.ID,
                        moduleName: u.moduleName,
                        instructorName: null,
                        instructorId: null
                    };
            });

            this.setState({
                modulePresenters: mp,
                //program: JSON.parse(JSON.stringify(selected)),
            });
        }).catch(error => {
            console.log("error:" + error);
            // this.setState({  // there is no error state
            //     error: error.message
            // });
        });
    }

    setFilteredOrgs = (cat) => {
        let filteredOrgs = []
        if (cat !== null) {
            filteredOrgs = this.state.organizations.filter(org => org.categoryId === cat.value)
        }
        this.setState({ organizationsFiltered: filteredOrgs })
    }

    onCategoryChange = (cat) => {
        this.setFilteredOrgs(cat)

        // clears organization ID (beacuse category changed, old organization no longer valid) (catvalue is string, org cat id is int)
        console.log("set organization null");
        this.setState({ organization: null })
    }

    onTextChange = event => {
        let { name, value } = event.target
        console.log(name);
        console.log(value);
        if(name==="cost" && value!=='') value=parseFloat(parseFloat(value).toFixed(2)) // for some reason toFixed was not seeing value as number
        this.setState({
            [name]: value
        });
    }

    // autocomplete changes
    onAutoChange = event => {
        // console.log("ON CHANGE CALLED",event.target.name,event.target.value)
        const { name, value } = event.target

        // if there is only one program in the list, and you try to clear the program do nothing
        if (name === "program" && value === null && this.state.programs.length === 1) {
            return
        }

        this.setState({
            [name]: value
        });

        // if the category is changing, update the filtered orgs with the correct category ID
        if (name === "category") {
            this.onCategoryChange(value)
        }


        // if the program changes, update module presenters with the module presenters from the program
        else if (name === "program") {
            this.onProgramChange(null, value) // not updated to async yet
        }

        else if (name === "locTemplate") {
            this.onLocTemplateChange(null, value) // not updated to async yet
        }

        else if (name === "contactTemplate") {
            this.onContactTemplateChange(null, value) // not updated to async yet
        }

    }

    //onAutoChangeProp = this.onAutoChange.bind(this)

    onModulePresenterChange = (moduleId, value) => {
        let selected = value;

        // changed this from "" to null to maintain consistency (see onProgramChange)
        if (selected === null) {
            selected = {
                label: null, //"",
                value: null, //""
            }
        }

        // finds the index of the module presenter to update
        const index = this.state.modulePresenters.findIndex(e => e.moduleId === moduleId);
        let newMP = [...this.state.modulePresenters];

        // updates the specified module presenter
        newMP[index] = { ...this.state.modulePresenters[index], instructorId: selected.value, instructorName: selected.label }
        this.setState({
            modulePresenters: newMP
        })
    }

    onLocTemplateChange = (name, value) => {
        let selected = value;
        console.log("onLocTemplateChange: " +selected);
        if (selected === null || selected === undefined) {
            this.setState({
                // locTemplate: '',
                locationName: '',
                locationStreet: '',
                locationCity: '',
                locationCounty: null,
                locationStateCode: null,
                locationZipcode: '',
                locationMapURL: ''
            });
            return;
        } 
        axios.get('/api/locationTemplate/' + selected.value, {
        }).then((res) => {
            // get counties call so that the county list has the right entries
            axios.get('/api/stateCounty/county/' + res.data.locTemplate.stateCode).then((res2)=>{
                const county = res2.data.map(u =>({ label: u.stateCountyName, value: u.stateCountyName }))
                this.setState({
                    // locTemplate: this.locTemplates.find(el => el.value === selected.value),
                    locationName: res.data.locTemplate.name,
                    locationStreet: res.data.locTemplate.street,
                    locationCity: res.data.locTemplate.city,
                    locationZipcode: res.data.locTemplate.zipCode,
                    locationMapURL: res.data.locTemplate.mapURL || '',
                    locationCounty: { label: res.data.locTemplate.countyCode, value: res.data.locTemplate.countyCode } ,
                    locationStateCode: { label: res.data.locTemplate.stateCode, value: res.data.locTemplate.stateCode },
                    counties: county,
                });
            })
            
        });
    }

    onContactTemplateChange = (name, value) => {
        let selected = value;
        if (selected === null) {
            this.setState({
                // contactTemplate: '',
                contactFirstname: '',
                contactLastname: '',
                contactPhone: '',
                contactEmail: ''
            });
            return;
        }

        axios.get('/api/contactTemplate/' + selected.value, {
        }).then((res) => {
            this.setState({
                // contactTemplate: this.contactTemplates.find(el => el.value === selected.value),
                contactFirstname: res.data.template.firstName,
                contactLastname: res.data.template.lastName,
                contactPhone: res.data.template.phone,
                contactEmail: res.data.template.email,
            });
        });
    }

    onDateChange = (id, event) => {
        this.setState({datesChanged: true})
        const index = this.state.dates.findIndex(e => e.ID === id);
        let newDates = [...this.state.dates];
        //find out the date element to be changed
        let oldDate = this.state.dates[index];
        if (event.target.name === 'date' && event.target.value) {
            let newDate = moment(event.target.value, moment.HTML5_FMT.DATE);
            newDates[index].fromDate = newDate.toISOString();
        }

        if (event.target.name === 'fromTime') {
            let newDate = moment(event.target.value, moment.HTML5_FMT.TIME);
            let newDatetime = moment(oldDate.fromDate).hour(newDate.hour()).minute(newDate.minute());
            newDates[index].fromDate = newDatetime.toISOString();

            console.log("New date",newDate.format(), newDatetime.format())

        }

        if (event.target.name === 'toTime') {
            if(oldDate.toDate === null){
                oldDate.toDate = moment(oldDate.fromDate)
            }
            let newDate = moment(event.target.value, moment.HTML5_FMT.TIME);
            let newDatetime = moment(oldDate.toDate).hour(newDate.hour()).minute(newDate.minute());
    
            newDates[index].toDate = newDatetime.toISOString();

        }

        this.setState({
            dates: newDates
        })
    }

    handleOptionChange = event => {
        // console.log("event:" + event.target.name + " id:" + event.target.value);

        if (event.target.value === 'isPublic') {
            this.setState({ [event.target.name]: true });
        } else {
            this.setState({ [event.target.name]: false });
        }
    }
    handleRemoteChange = event => {
        if (event.target.value === 'isRemote') {
            this.setState({ [event.target.name]: true, costErrorMessage: 'Cost must be less than $10' });
            
        } else {
            this.setState({ 
                [event.target.name]: false,
                remotePlatform: '',
                costErrorMessage: 'Cost must be less than $30'
            });
        }
    }

    onStateChange = (event) => {
        let {value} = event.target;
        const selected = value
        
        if (selected === null) {
            this.setState({
                locationStateCode: null,
                locationCounty: null,
                counties: []
            })
            return;
        }

        let selectedState = selected.value;
        axios('/api/stateCounty/county/' + selectedState, {
            method: 'GET'
        })
            .then(res => res.data)
            .then(result => {
                let county = [];
                result.map((u) =>
                    county.push({ label: u.stateCountyName, value: u.stateCountyName })
                );
                this.setState({
                    locationStateCode:  JSON.parse(JSON.stringify(selected)),
                    counties: county
                })
            }).catch(error => {
                console.log("error:" + error);
                this.setState({
                    error: error.message
                });
            });

       // this.setState({ locationState: JSON.parse(JSON.stringify(selected)) });
    }

    // check if a waiver is needed
    waiveRequired = () => {
        console.log("In check neeed")

        // check if user has role “Classroom Training Administrator” or "Program Coordinator”, if so, they don't need to fill out waiver
        console.log(this.context.roles)
        const roles = this.context.roles
        const admin = (roles.isClassroomTrainingAdmin===1 || roles.isProgramCoordinator===1)

        // no waiver required for admin or if the class is published (see datesDisabled)
        if(admin || this.state.datesDisabled){
            return false
        }

        // check if the waiver already exists, but the dates on the classes did not change -> don't need a new waiver (doesn't need to redirect)
        if(this.state.hasWaiver && !this.state.datesChanged){
  
  
  
            console.log("dates didn't change")
            return false
        }

        //checks the dates, if one is within 30 days, then a waive form is required
        const now = moment()
        let required = false
        this.state.dates.forEach((date)=>{
            // const timeDif = moment.duration(moment(date.fromDate).diff(now)).asDays()
            const timeDif = moment(date.fromDate).diff(now, 'days') // rounds difference down
            console.log("Dif", timeDif, timeDif<30)

            if(timeDif < 30) required = true
        })

        if(required) return true

        console.log("No waiver required")
        return false
    }

    // handles create and update
    onSave = event => {
        console.log("In save")
        
        const needWaiver = this.waiveRequired()
        console.log("New waiver required?",needWaiver)

        // if a waiver is needed, open a pop-up box -> if confirmed submit the workshop and redirect to waiver
        // if not confirmed, don't submit the workshop
        if(needWaiver){
            this.openDialog() //submission handles within dialog
        } else {
            // if no waiver is needed, just submit the workshop and get redirected to previous page
            this.postWorkshop(needWaiver)
        }
        return
    }

    postWorkshop = async (needWaiver) => {
        if (this.state.submitting)
            return;

        this.setState({submitting: true});
        let url = "/api/workshop/";
        let token = sessionStorage.getItem('accessToken');

        // if updating
        if (this.state.id) {
            url = url + this.state.id;
        }

        console.log("In post: ")
        console.log("check audience ", this.state.audience)
        
       
        var data = {
            lang: this.state.lang.value,
            maxParticipants: this.state.maxParticipants,
            minParticipants: this.state.minParticipants,
            cost: this.state.cost,
            notes: this.state.notes, // the event day detail
            isPublic: this.state.isPublic,
            isRemote: this.state.isRemote,
            remotePlatform: this.state.remotePlatform,
            workshopID: this.state.workshopID, // gets ignored if not update
            advertisingWebSite: this.state.advertisingWebSite,
            regExtUrl: this.state.regExtUrl,
            dates: this.state.dates,
            leadInstructorId: this.state.leadInstructor.value,
            //leadInstructorName: this.state.leadInstructor.label,
            //seniorInstructorId:  this.state.seniorInstructor.value,
            categoryID: this.state.category.value,
            catCode: this.state.category.categoryCode, 
            organizationId: this.state.organization.value,
            organizationName: this.state.organization.label,
            organizationCode: this.state.organization.organizationCode, 
            // description: this.state.description, // class description get set in the backend
            workshopProgram: this.state.program.value,
            regCloseDate: this.state.regCloseDate,
            contactID: this.state.contact.ID,
            contactFirstname: this.state.contactFirstname,
            contactLastname: this.state.contactLastname,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            locationID: this.state.location.ID,
            locationName: this.state.locationName,
            locationStreet: this.state.locationStreet,
            locationCity: this.state.locationCity,
            locationCounty: this.state.locationCounty ? this.state.locationCounty.value : null,
            locationStateCode:  this.state.locationStateCode ? this.state.locationStateCode.value : null,
            locationZipcode: this.state.locationZipcode,
            locationMapURL: this.state.locationMapURL,
            modulePresenters: this.state.modulePresenters,
            audience: this.state.audience,

            // trainingProviderId: (this.props.location.state && this.props.location.state.trainingProvider) ? this.props.location.state.trainingProvider.id : null,
            trainingProviderId: this.state.trainingProviderId,
            oldTrainingProviderId: this.state.trainingProvider.id,
            trainingProviderName: this.state.trainingProvider.name,

            // used to set the status when a workshop is first created, if an admin then don't need to check dates
            isAdmin: (this.context.roles.isClassroomTrainingAdmin===1 || this.context.roles.isProgramCoordinator===1),
            trainingCode : this.state.isRemote? this.state.trainingCode : null,
            byUser : this.context.user.username,
            needWaiver: needWaiver
        }

        console.log('data for update', data)

        try {
            let response = await axios(url, {
                method: 'POST',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (response.status >= 400) {   
                console.log(response.statusText);              
                throw new Error(response.statusText);
            }

            const classID = response.data.workshopId || this.state.id
           this.setState({submitting: false});
            if(needWaiver) 
                this.props.history.push("/class/"+ classID + "/waive") 
            else 
            this.props.history.goBack();
        } catch(error) {
           throw error; //handle by App.js
        }
    }

    onCancel = event => {
        this.props.history.goBack();
    }

    onAddDate = event => {
        let newDates = [...this.state.dates];
        newDates.push({
            ID: moment().valueOf(),
            fromDate: null, //moment(),
            toDate: null, //moment(),
            workshopId: this.state.id
        });
        // console.log(newDates);
        this.setState({
            dates: newDates
        })
        this.setState({datesChanged: true})

    }

    removeDate = id => {
        console.log("Remove date clicked: ", id)
        const newDates = this.state.dates.filter((d)=>d.ID !== id)
        console.log(newDates)
        this.setState({
            dates: newDates
        })
        this.setState({datesChanged: true})
    }


    onAddLocationTemplate = event => {
        let token = sessionStorage.getItem('accessToken');
        let url = "/api/locationTemplate";
        let data = {
            name: this.state.locationName,
            countyCode: this.state.locationCounty.value,
            city: this.state.locationCity,
            street: this.state.locationStreet,
            stateCode: this.state.locationStateCode.value,
            zipCode: this.state.locationZipcode,
            mapURL: this.state.locationMapURL,
            byUsername: this.context.user.username
        }
        axios(url, 
             {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }, data})
        .then(response => {
            console.log(response);
            if (response.status === 200) {
                let loc = {label: response.data.loc.name, value: response.data.loc.ID}
                let locTemplates = [];

                axios.get('/api/locationTemplate/').then((res) => {
                    res.data.locTemplates.forEach((u) => {
                        locTemplates.push({ label: u.name, value: u.ID });
                    });            
                    this.setState({
                        locTemplates: locTemplates,
                        locTemplate: loc
                    });
                });
            }
        });

    }

    onAddContactTemplate = event => {
        var url = "/api/contactTemplate";
        let token = sessionStorage.getItem('accessToken');

        var data = {
            firstName: this.state.contactFirstname,
            lastName: this.state.contactLastname,
            email: this.state.contactEmail,
            phone: this.state.contactPhone,
            byUsername: this.context.user.username,
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data})
        .then(response => {
            if (response.status === 200) {
                let contactTemplates = [];
                let contact = {label: response.data.contact.lastName + ', ' + response.data.contact.firstName , value: response.data.contact.ID}

                axios.get('/api/contactTemplate/').then((res) => {
                    res.data.templates.forEach((u) => {
                        contactTemplates.push({ label: u.lastName + ', ' + u.firstName, value: u.ID });
                    });            
                    this.setState({
                        contactTemplates: contactTemplates,
                        contactTemplate: contact
                    });
                });
            }
        });
    }
    onRegister = event => {
        if (this.state.regExtUrl !== null)
            window.open(this.state.regExtUrl, "_blank");
        else 
            this.setState({error: "no registration URL available"});
    }

    async componentDidMount() {
        const ID = this.props.match.params.id

        var program = null// handles the program changing for module presenters
        let category = null //handles cat changing for filtered orgs
        console.log("ID",ID)
        console.log('props', this.props);
        try {
            // grab field options (for autocomplete)
            const options = await getTrainingProviderOptions()
            //console.log("options:" +  JSON.stringify(options))
            this.setState(options)

            // if ID is defined, load workshop data
            if (ID) {
                const data = await getWorkshopData(ID, options, languages)
                console.log("Update Data",data)
                this.setState(data)
                const roles = this.context.roles
                const admin = (roles.isClassroomTrainingAdmin===1 || roles.isProgramCoordinator===1)
                console.log("In Mount, logging permissions","admin",admin,"status",data.status,"disabled",data.status===1 && !admin)
                this.setState({datesDisabled: (data.status===1 && !admin)})

                program = data.program
                category = data.category

                //also load in  the counties list, otherwise there would be no counties options by default
                const res = await axios.get('/api/stateCounty/county/' + data.locationStateCode.value)
                console.log("Grabbed county list id", res)
                const counties = res.data.map(u =>({ label: u.stateCountyName, value: u.stateCountyName }))
                this.setState({counties,})

               
            } else {
                 // if the ID is not defined, default FL as the location state
                 this.setState({
                    locationStateCode: { label: 'FL', value: 'FL' }
                 })
                  //also load in  Florida counties list, otherwise there would be no counties options by default
                const res = await axios.get('/api/stateCounty/county/FL')
                console.log("Grabbed county list", res)
                const counties = res.data.map(u =>({ label: u.stateCountyName, value: u.stateCountyName }))
                this.setState({counties,})

                 // and no current dates, add a date
                if (this.state.dates.length === 0) 
                    this.onAddDate();
            } 

            // if the training provider is defined, load that template
            if (this.props.location.state && this.props.location.state.trainingProvider) {
                const data = await getTrainingProviderData(this.props.location.state.trainingProvider.id, options)
                console.log("language: " + data)

                const fields = {
                    trainingProviderId:  this.props.location.state.trainingProvider.id,
                    category: data.categoryID,
                    lang: (data.lang !== null) ? languages.find((lang) => lang.value === data.lang) : null,
                    maxParticipants: data.maxParticipants,
                    minParticipants: data.minParticipants,
                    cost: data.cost,

                    isPublic: data.isPublic,

                    audience: data.audience,

                    locTemplate: data.location_id,
                    leadInstructor: data.leadInstructorId,

                    contactTemplate: data.contact_id,

                    organization: data.organizationId,
                    program: data.workshopProgram,
                }

                // also load in the contact template extra info
                this.onContactTemplateChange(null, data.contact_id)

                //also load in locTemplate info
                this.onLocTemplateChange(null, data.location_id)

                category = fields.category

                this.setState(fields)
                program = fields.program
            }

           

            // if there is only one program then set the program to that
            if (!program && options.programs.length === 1) {
                program = options.programs[0]
                this.setState({ program, })
            }
            // handle cat change for filtered orgs
            this.setFilteredOrgs(category)
            console.log('training Provider name', this.state.trainingProviderName)

            this.getTrainingProviders()

            // handle the programChange for module presenters, 
            console.log("program: "+ program)
            this.onProgramChange(null, program);
            this.setState({ loading: false })

        } catch (err) {
            console.log("error:" + err);
            this.setState({error: err.message})
            this.setState({ loading: false })
        }
    }

    componentWillUnmount = () => {
        if (ValidatorForm.hasValidationRule('isLess25')) {
            ValidatorForm.removeValidationRule('isLess25');
        }

        if (ValidatorForm.hasValidationRule('checkTrainingDate'))
        ValidatorForm.removeValidationRule('checkTrainingDate');
    }


    // dialog methods
    closeDialog = () => {
        this.setState({showDialog: false})
    }
    openDialog = () => {
        this.setState({showDialog: true})
    }
    confirmDialog= () => {
        console.log("Dialog confirmed")
        this.postWorkshop(true)
        this.closeDialog()
    }

    renderReadonly(classes) {

        const onlyAdmin = (this.context.roles.isClassroomTrainingAdmin===1 || this.context.roles.isProgramCoordinator===1)

        return (
            <div>
                <div className={classes.root}>
                    <dl className="workshop-details">
                        <dt>Language:</dt>
                        <dd>{this.state.lang.label}</dd>

                        <dt>{"Dates & Times:"}</dt>
                        <dd>
                            {this.state.dates.map(d =>
                                <p key={d.ID}>
                                    {moment(d.fromDate).format('LLL') + ' - ' + moment(d.toDate).format('LT')}
                                </p>
                            )}
                        </dd>

                        {
                            onlyAdmin
                            ?
                            <>
                            <dt>Training Provider: </dt>
                            <dd>{this.state.trainingProviderName} </dd>
                            <dt> Created By: </dt>
                            <dd>{this.state.byUser} </dd>
                            <dt> Last Modified By: </dt>
                            <dd>{this.state.lastModifiedByUserName} </dd>
                            </>
                            :
                            <></>
                        }

                        <dt>Location:</dt>
                        {!this.state.isRemote &&
                        <dd>

                            <p>{this.state.location && this.state.location.NAME}</p>
                            <p>{this.state.location && this.state.location.STREET}</p>
                            <p>{this.state.location && this.state.location.CITY + ', ' + this.state.location.STATECODE + this.state.location.ZIPCODE}</p>

                            {this.state.location && this.state.location.mapURL &&
                                <a style={anchorColor} href={this.state.location.mapURL} > Map URL for this training location</a>
                            }
                        </dd>
                        }
                        {this.state.isRemote &&
                        <dd>
                            <p>Live Online Session</p>
                            <p>{this.state.remotePlatform}</p>
                        </dd>
                        }

                        <dt>Cost: </dt>
                        {this.state.isRemote &&
                            <dd>{"$" + this.state.cost} for class + $15.00 for test</dd>
                        }
                        {!this.state.isRemote &&
                            <dd>{"$" + this.state.cost} (includes test)</dd>
                        }
                        <dt>Registration Closing Date:</dt>
                        <dd>{moment(this.state.regCloseDate).format('LL, dddd')}</dd>
 
                        <dt>Open to Public or Private:</dt>
                        <dd>{this.state.isPublic ? 'Public' : 'Private'}</dd>

                        {!this.state.isPublic && 
                            <div>
                            <dt>Class Audience:</dt>
                            <dd>{this.state.audience}</dd>
                            </div>
                        }
                       <dt>Contact Name:</dt>
                        <dd>{this.state.contact ? this.state.contact.FIRSTNAME + ' ' + this.state.contact.LASTNAME : "Not Available"}</dd>

                        <dt>Contact Phone:</dt>
                        <dd>{this.state.contact ? this.state.contact.PHONE : "Not Available"}</dd>

                        <dt>Contact Email:</dt>
                        <dd><a style={anchorColor} href={'mailto:' + this.state.contact.EMAIL + '?subject=Class Details'}>{this.state.contact.EMAIL} </a> </dd>

                        <dt>Event Day Details:</dt>
                        <dd>
                            {this.state.notes}
                            {this.state.regExtUrl && <a style={anchorColor} href={this.state.regExtUrl} > more information...</a>}

                        </dd>

                        <dt>Lead Instructor:</dt>
                        <dd>{this.state.leadInstructor ? this.state.leadInstructor.label : ""}</dd>

                        <dt>Organization:</dt>
                        <dd>
                            {this.state.organization &&
                                <p>{this.state.organization.label}</p>
                            }
                        </dd>

                        <dt>Class ID:</dt>
                        <dd>{this.state.workshopID}</dd>

                        <dt>Module Presenters:</dt>
                        <dd style={{ width: 'fit-content' }}>
                            <dl>
                                {this.state.modulePresenters.map(mp =>
                                    mp.instructorName &&
                                    <div key={'mp' + mp.moduleId}>
                                        <dt>{`${mp.moduleName}: `}</dt>
                                        <dd>{mp.instructorName}</dd>
                                    </div>
                                )}
                            </dl>
                        </dd>
                       
                        <dt>Training Program:</dt>
                        <dd>{this.state.program ? this.state.program.label : "Invalid program"}</dd>

                        <dt>Class Description:</dt>
                        <dd>{this.state.description}</dd>

                        <dt>Max Participants:</dt>
                        <dd>{this.state.maxParticipants}</dd>
                       
                    </dl>
                </div>
            </div>
        );
    }

    async getTrainingProviders() {
        const res = await axios.get('/api/usergroup/list/trainingProvider', {
        });

        let trainingProviders = [];

        let resultData = res.data.providers

        if (resultData.length > 0) {
            resultData.map((u) =>
                trainingProviders.push({ id: u.id, name: u.name, })
            )
        };
        this.setState({
            trainingProviders: trainingProviders
        })

        if(this.state.trainingProviderId){
            console.log('training Provider id', this.state.trainingProviderId)

            let idTP = this.state.trainingProviderId
            for(let i=0;i < trainingProviders.length; i++ ){
                if( trainingProviders[i].id === idTP   ){
                    console.log('filtered TP', trainingProviders[i])
                    this.setState({
                        trainingProvider : trainingProviders[i],
                        trainingProviderName :  trainingProviders[i].name
                    })
                }
            }
        }


    }

    onTrainingProviderSelect = (name, value) => {

        let selected = name;

        console.log('selected', value, 'name', name)

        if (selected === null) {
            this.setState({
                trainingProvider: null,
                trainingProviderId: 'null'
            })
            // setTrainingProvider(null)
            sessionStorage.removeItem('adminSelectedTP')
            // setData(null)
            this.getTrainingProviders();
            return;
        }
        this.setState({
            trainingProvider:  {id:selected.id, name: selected.name},
            trainingProviderId: selected.id
        })
        // setTrainingProvider({id:selected.id, name: selected.name} );
        // sessionStorage.setItem('adminSelectedTP', JSON.stringify(selected))

        getTrainingProviderData(selected.id);
    }

    renderEditing(classes) {

        const onlyAdmin = (this.context.roles.isClassroomTrainingAdmin===1 || this.context.roles.isProgramCoordinator===1)

        return <>
            <WaiveDialog
                open={this.state.showDialog}
                onClose={this.closeDialog}
                onConfirm={this.confirmDialog}
            />
            <Grid container  spacing={3}>
                
                {this.state.workshopID && 
                <Grid item xs={12} md={3}>

                    <TextField 
                        id="standard-basic" 
                        label="Class ID" 
                        type="text" 
                        className={[classes.textField].join(' ')} 
                        value={this.state.workshopID} 
                        name='workshopID' 
                        fullWidth
                        disabled 
                    />
                
                    {console.log('admin stat', onlyAdmin)}
                </Grid>
                }

                { onlyAdmin
                        ?
                        <>
                        {
                            console.log('checking the training provider', this.state.trainingProviderId)
                        }
                             {/* <Grid item xs={12} md={3}>
                                <TextField 
                                        xs={12}
                                        md={4}
                                        id="standard-basic" 
                                        label="Training Provider" 
                                        type="text" 
                                        onChange={this.onAutoChange}
                                        className={[classes.textField].join(' ')} 
                                        value={this.state.trainingProviderId} 
                                        name='trainingProviderId'
                                        fullWidth
                                        disabled  
                                        />
                            </Grid> */}
                            <Grid item xs={12}  md={4}>
                                    <Autocomplete
                                        id="trainingProviders"
                                        options={this.state.trainingProviders}
                                        getOptionLabel={(option) => option.name}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={(event, value) => this.onTrainingProviderSelect(value)}
                                        value={this.state.trainingProvider || null}
                                        className={'class-admin-trainingProviders'}
                                        renderInput={(params) => <TextField {...params} label="Select Training Provider" />}
                                        disabled={this.state.trainingProviders.length === 0}
                                    />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                    <TextField 
                                    xs={12}
                                    md={4}
                                    id="standard-basic" 
                                    label="Created By" 
                                    type="text" 
                                    onChange={this.onAutoChange}
                                    className={[classes.textField].join(' ')} 
                                    value={this.state.byUser || '' } 
                                    name='byUser'  
                                    fullWidth
                                    disabled
                                    />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                    <TextField 
                                    xs={12}
                                    md={4}
                                    id="standard-basic" 
                                    label="Last Modified By" 
                                    type="text" 
                                    onChange={this.onAutoChange}
                                    className={[classes.textField].join(' ')} 
                                    value={this.state.lastModifiedByUserName || '' } 
                                    name='lastModifiedByUserName'  
                                    fullWidth
                                    disabled
                                    />
                            </Grid>

                        </>
                        :
                        <></>
                    }

               
                
                <GridAutoTextValidator
                    xs={12}
                    md={4}
                    name="category"
                    options={this.state.categories}
                    value={this.state.category}
                    onChange={this.onAutoChange}
                    classes={classes}
                    validators={['required']}
                    errorMessages={['Category is required']}
                    required
                    label="Category"
                />

                <GridAutoTextValidator
                    xs={12}
                    md={4}
                    name="organization"
                    options={this.state.organizationsFiltered}
                    value={this.state.organization}
                    onChange={this.onAutoChange}
                    classes={classes}
                    validators={['required']}
                    errorMessages={['Organization is required']}
                    disabled={this.state.category === null}
                    required
                    label="Organization"
                />
                <GridAutoTextValidator
                    xs={12}
                    md={4}
                    name="lang"
                    options={languages}
                    value={this.state.lang}
                    onChange={this.onAutoChange}
                    classes={classes}
                    validators={['required']}
                    errorMessages={['Language is required']}
                    required
                    label="Language"
                />
                   <Grid item xs={12}>
                    <FormLabel component="legend">{"Dates & Times"}</FormLabel>

                    {this.state.dates.map(d =>
                        <Grid key={d.ID + 'row'} container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <TextValidator
                                    key={d.ID + 'Date'}
                                    label="Training Date"
                                    type="date"
                                    name='date'
                                    value={d.fromDate ? moment(d.fromDate).format('YYYY-MM-DD') : ''}
                                    className={[classes.textField].join(' ')}
                                    onChange={(event) => this.onDateChange(d.ID, event)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    validators={['checkTrainingDate', 'required']}
                                    errorMessages={['Please enter a future date', 'Date is required']}
                                    fullWidth
                                    required
                                    disabled={this.state.datesDisabled}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextValidator
                                    key={d.ID + 'fromTime'}
                                    label="Start Time"
                                    type="time"
                                    name='fromTime'
                                    value={d.fromDate ? moment(d.fromDate).format('HH:mm') : ''}
                                    className={[classes.textField].join(' ')}
                                    onChange={(event) => this.onDateChange(d.ID, event)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    validators={['required']}
                                    errorMessages={['Start time is required']}
                                    fullWidth
                                    required
                                    disabled={this.state.datesDisabled || d.fromDate===null}
                                />
                            </Grid>
                            <Grid item xs={12} md={this.state.dates.length > 1 ? 3: 4}>
                                <TextValidator
                                    key={d.ID + 'toTime'}
                                    label="End Time"
                                    type="time"
                                    name='toTime'
                                    value={d.toDate ? moment(d.toDate).format('HH:mm') : ''}
                                    className={[classes.textField].join(' ')}
                                    onChange={(event) => this.onDateChange(d.ID, event)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    validators={['required']}
                                    errorMessages={['End time is required']}
                                    fullWidth
                                    required
                                    disabled={this.state.datesDisabled || d.fromDate===null}
                                />
                            </Grid>

                            {this.state.dates.length > 1 &&
                                <Grid item xs={12} md={1} >
                                    <Button variant="contained" className={this.props.classes.deleteButton} onClick={()=>this.removeDate(d.ID)}>
                                        <DeleteIcon />
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    )}
                    <Box mt={3}>
                        <Button disabled={this.state.datesDisabled} variant="outlined" color="primary" className={[].join(' ')} onClick={this.onAddDate} >ADD ANOTHER DATE/TIME FOR CONTINUATION OF THIS CLASS</Button>
                    </Box>
                </Grid>

                <GridAutoTextValidator
                    xs={12}
                    md={4}
                    name="leadInstructor"
                    options={this.state.leadInstructors}
                    value={this.state.leadInstructor}
                    onChange={this.onAutoChange}
                    classes={classes}
                    validators={['required']}
                    errorMessages={['Lead instructor is required']}
                    required
                    label="Lead Instructor"
                />

                <Grid item xs={12} md={4}>
                    <TextValidator
                        label="Registration Closing Date"
                        type="date"
                        name='regCloseDate'
                        value={this.state.regCloseDate}
                        className={[classes.textField].join(' ')}
                        onChange={this.onTextChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        validators={['checkTrainingDate','required']}
                        errorMessages={['Please enter a future date', 'Closing date is required']}
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12}  md={4}>
                    <TextValidator
                        id="standard-basic"
                        label="Registration URL ex. Eventbrite"
                        type="text"
                        className={[classes.textField].join(' ')}
                        onChange={this.onTextChange}
                        value={this.state.regExtUrl ? this.state.regExtUrl : ''}
                        name='regExtUrl'
                        inputProps={{ maxLength: 255}}
                        fullWidth
                    />
                </Grid>

                 <Grid item xs={12} sm={6}>
                    <br />
                    <FormLabel component="legend">Public / Private?</FormLabel>
                    <RadioGroup row aria-label="open" name="open" onChange={this.handleOptionChange}>
                        <FormControlLabel
                            id="isPublic"
                            value="isPublic"
                            checked={this.state.isPublic}
                            control={<Radio color="primary" />}
                            label="Public"
                            name="isPublic"
                        />
                        <FormControlLabel
                            id="isPrivate"
                            value="isPrivate"
                            checked={!this.state.isPublic}
                            control={<Radio color="primary" />}
                            label="Private"
                            name="isPublic"
                        />
                    </RadioGroup>
                </Grid>

                {
                    this.state.isPublic
                    ?
                    <></>
                    :
                    <Grid item xs={12} sm={6}>
                        <TextField 
                        id="standard-basic" 
                        label="Class audience (organization): " 
                        type="text" 
                        className={[classes.textField].join(' ')} 
                        onChange={this.onTextChange} 
                        value={this.state.audience || ""} 
                        name='audience' 
                        fullWidth
                        />
                    </Grid>
                }
                
                

                <>
                    <Grid item xs={12} sm={6}>
                        <br />
                        <FormLabel component="legend">In Person / Remote ?</FormLabel>
                        <RadioGroup row aria-label="open" name="open" onChange={this.handleRemoteChange}>
                            <FormControlLabel
                                id="isInPerson"
                                value="isInPerson"
                                checked={!this.state.isRemote}
                                control={<Radio color="primary" />}
                                label="In Person"
                                name="isRemote"
                            />
                            <FormControlLabel
                                id="isRemote"
                                value="isRemote"
                                checked={this.state.isRemote}
                                control={<Radio color="primary" />}
                                label="Remote (Zoom, etc.)"
                                name="isRemote"
                            />
                        </RadioGroup>
                    
                    </Grid>

                    {
                        this.state.isRemote
                        ?
                        <Grid item xs={12} sm={6}>
                            <TextField id="standard-basic" label="Platform (Zoom, Teams, etc.)" type="text" className={[classes.textField].join(' ')} onChange={this.onTextChange} value={this.state.remotePlatform || ""} name='remotePlatform' fullWidth/>
                        </Grid>
                        :
                        <></>
                    }

                    
                </>

                {
                    this.state.isRemote
                    ?
                    < >
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    id="trainingCode"
                                    label= "Class Completion Code"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    value={this.state.trainingCode}
                                    name='trainingCode'
                                    fullWidth
                                    disabled
                                />
                        </Grid>
                    <Grid item xs={12} sm={6} >
                        <TextField
                                    id="usedBy"
                                    label= "Test By Date"
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    value={this.state.usedBy}
                                    name='usedBy'
                                    fullWidth
                                    disabled
                                />
                        </Grid>
                    </>
                    :
                    <></>
                }
             
                <Grid item xs={12} sm={6}>
                    <TextValidator
                        id="standard-basic"
                        label="Cost (limit $30 in-person, $10 Remote)"
                        type="number"
                        className={[classes.textField].join(' ')}
                        onChange={this.onTextChange}
                        value={this.state.cost} name='cost'
                        validators={['required', 'minNumber:0', 'isLess25',]}//'matchRegexp:^[0-9]*3$','isNumber']}
                        errorMessages={['Cost is required', 'Cost must be positive', this.state.costErrorMessage ]} //,'RegExp','Only numbers are allowed']}
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextValidator
                        id="standard-basic"
                        label="Maximum Participants"
                        type="number"
                        className={[classes.textField].join(' ')}
                        onChange={this.onTextChange}
                        value={this.state.maxParticipants} name='maxParticipants'
                        validators={['required', 'isNumber','minNumber:0']}
                        errorMessages={['maxParticipants is required', 'Whole numbers only','Participants must be positive']}
                        fullWidth
                        required
                    />
                </Grid>
                {!this.state.isRemote &&
                    <LocationBox 
                            locTemplates = {this.state.locTemplates}
                            locTemplate = {this.state.locTemplate}
                            onAutoChange = {this.onAutoChange} 
                            classes = {classes}
                            onAddLocationTemplate = {this.onAddLocationTemplate}
                            onTextChange = {this.onTextChange} 
                            locationName = {this.state.locationName}
                            locationStreet = {this.state.locationStreet}
                            locationCity = {this.state.locationCity}
                            counties = {this.state.counties}      
                            locationCounty = {this.state.locationCounty}
                            locationStateCode = {this.state.locationStateCode}
                            states = {this.state.states}
                            onStateChange = {this.onStateChange} 
                            locationZipcode = {this.state.locationZipcode}
                            locationMapURL = {this.state.locationMapURL}
                    />
                }
                <ContactBox 
                        contactTemplates = {this.state.contactTemplates}
                        contactTemplate = {this.state.contactTemplate}
                        onAutoChange = {this.onAutoChange} 
                        classes = {classes}
                        onAddContactTemplate = {this.onAddContactTemplate}
                        onTextChange = {this.onTextChange}
                        contactFirstname = {this.state.contactFirstname}
                        contactLastname = {this.state.contactLastname}
                        contactPhone = {this.state.contactPhone}
                        contactEmail = {this.state.contactEmail}
                    />
                <Grid container  spacing={3}>

                

                <GridAutoTextValidator
                    xs={12}
                    name="program"
                    options={this.state.programs}
                    value={this.state.program}
                    onChange={this.onAutoChange}
                    classes={classes}
                    validators={['required']}
                    errorMessages={['Training Program is required']}
                    required
                    label="Training Program"
                />

                <Grid item xs={12}>
                    <p>Please provide details the class attendees need to know, such as meals, directions, parking, pre-registration, payment/refund policy, COVID-19 instructions, etc.</p>
                </Grid>
                <Grid item xs={12}>
                    <TextField id="standard-basic" label="Class Details" type="text" className={[classes.textField].join(' ')} onChange={this.onTextChange} value={this.state.notes} name='notes' multiline fullWidth maxRows={10} />
                </Grid>
                <Grid item xs={12}>
                    <br />
                    <FormLabel component="legend">{"Module Presenters"}</FormLabel>

                    {this.state.modulePresenters.map(mp =>
                        <Grid key={'mp' + mp.moduleId} container spacing={3}>
                            <Grid item xs={12}>

                                <Autocomplete
                                    options={this.state.instructors}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, val) => option.value === val.value}
                                    onChange={(event, value) => this.onModulePresenterChange(mp.moduleId, value)}
                                    className={[classes.autoComplete].join(' ')}
                                    value={(mp !== null && mp.instructorId !== null) ? { label: mp.instructorName, value: mp.instructorId } : null}
                                    autoHighlight
                                    renderOption={(props, option) => {
                                        return (
                                          <li {...props} key={option.value}>
                                            {option.label}
                                          </li>
                                        );
                                    }}                                    
                                    renderInput={(params) => <TextField {...params} label={mp.moduleName} />}
                                />

                            </Grid>
                        </Grid>
                    )}
                </Grid>
                </Grid>
            </Grid>
          
        </>;
    }

    renderInfo(classes) {
        // when loading in API data
        if (this.state.loading) 
            return <Loading />
        else if(this.state.error!=='') return <h1>{this.state.error}</h1>
        
        // if the ID is defined but not editing
        else if (this.props.match.params.id && !this.editing) {
            // else if (!this.editing && this.state.id !== null) {
            return this.renderReadonly(classes);

            // all other instances
        } else {
            return this.renderEditing(classes);
        }
    }

    handleInvalid(errors){
        // this focuses on the first component with a validation error
        const focusElem = document.getElementsByName(errors[0].props.name)
        if(focusElem.length === 1)
            focusElem[0].focus()
        
        // it seems like if it finds an autocomplete, there is a div and then an input with the same name. .focus does not seem to work on the div's
        else
            focusElem[1].focus()
            
        console.log(errors)
        console.log(errors[0].props.name)

    }

    

    render() {
        const { classes } = this.props;

        console.log()

        return (
            <ValidatorForm
                noValidate
                onError={this.handleInvalid} //called on a validation error, used to focus the first element
                onSubmit={(this.editing|| this.state.id === null) ? this.onSave : this.onRegister}
            >
                <Fragment>
                    <PageHeader
                        title={"Class Details"}
                        cancel={this.onCancel}
                        actionButtons={(this.editing || this.state.id === null) ? [{ label: "Save", disabled: this.state.submitting}] : (this.state.regExtUrl) ? [{ label: "Register" }] : [] }
                    />

                    {this.renderInfo(classes)}
                    <PageFooter
                    actionButtons={(this.editing || this.state.id === null) ? [{ label: "Save", disabled: this.state.submitting }] : (this.state.regExtUrl) ? [{ label: "Register" }] : [] }
                    />
                </Fragment>
            </ValidatorForm>
        );
    }
}

// export default Workshop;
export default withStyles(styles, { withTheme: true })(Workshop);
